module.exports = __webpack_public_path__ + "img/arw-more.68373e42.svg";